const RequestCards = ({ rows = [] }) => {
    if (!rows.length) {
        return <p className="info-text text-center">No requests found</p>;
    }

    return (
        <div className="card-table-container flex flex-col gap-[15px] md:hidden mt-[15px]">
            {rows.map((row, idx) => (
                <div
                    key={row._id || idx}
                    className="border border-gray-300 rounded-lg p-6 w-full bg-white"
                >
                    <div className="detail-row -mt-[10px] mb-2">
                        <div className="detail-column">
                            <p className="detail-label">Unit</p>
                            <p className="detail">{row.unit?.unitNumber || '—'}</p>
                        </div>
                        <div className="detail-column">
                            <p className="detail-label">Type</p>
                            <p className="detail">{row.type}</p>
                        </div>
                    </div>

                    <div className="detail-row mb-2">
                        <div className="detail-column">
                            <p className="detail-label">Status</p>
                            <span className={`request-status-badge ${row.status?.toLowerCase()}`} style={{ display: 'flex', justifyContent: 'center' }}>
                                {row.status}
                            </span>
                        </div>
                        <div className="detail-column">
                            <p className="detail-label">Priority</p>
                            <p className="detail">{row.details?.priority || '—'}</p>
                        </div>
                    </div>

                    <div className="detail-column">
                        <p className="detail-label">Requested On</p>
                        <p className="detail">{new Date(row.createdAt).toLocaleDateString()}</p>
                    </div>

                    <div className="detail-column mb-4">
                        <p className="detail-label">Description</p>
                        <p className="detail whitespace-pre-wrap">{row.description}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default RequestCards;
